module.exports = __webpack_public_path__ + "img/greeting_graphic.071393e5.png";